module.exports = __webpack_public_path__ + "static/media/drop.4652ed38.svg";